/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable prefer-const */
/* eslint-disable react/destructuring-assignment */
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  Alert,
  Badge,
  Button,
  DatePicker,
  Drawer,
  Form,
  Input,
  Modal,
  Popover,
  Skeleton,
  Spin,
  TimePicker,
  Tooltip,
  message,
} from "antd";
import dayjs from "dayjs";
import { isEmpty } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  LuClock,
  LuBraces,
  LuCalendarCheck,
  LuCalendarClock,
  LuCalendarPlus,
  LuCar,
  LuCircleX,
  LuFileText,
  LuImagePlay,
  LuLayoutTemplate,
  LuMailSearch,
  LuMessageSquareQuote,
  LuNotebookPen,
  LuPaperclip,
  LuPencil,
  LuPhone,
  LuPlus,
  LuSend,
  LuSmile,
  LuVideo,
} from "react-icons/lu";
import { resetAppointmentFilters } from "../../../redux/slices/appointmentSlice";
import {
  CREATE_SCHEDULED_EMAIL,
  CREATE_SCHEDULED_MESSAGE,
  SAVE_AS_DRAFT,
  UPDATE_SCHEDULED_EMAIL,
} from "../../../graphql/mutation";
import {
  GET_COMPANY_DOCUMENTS,
  GET_COMPANY_WORK_HOURS,
  GET_ENGAGEMENT_MESSAGE_TEMPLATES,
  GET_ENGAGEMENT_TEMPLATE_TEXT,
  GET_INITIAL_REVIEW_MESSAGE,
  GET_SCHEDULED_EMAILS_FOR_LEAD,
} from "../../../graphql/query";
import { resolveLeadOpportunityId } from "../../../helpers/opportunityHelper";
import {
  DATE_TIME_FORMATS,
  formatDate,
  formatUtcToLocal,
  getScheduleTimezone,
  getWorkingHoursDisabledDate,
  getWorkingHoursDisabledTime,
  viewerZoneEquivalent,
} from "../../../utils/dateTimes";
import CustomButton from "../../commonComponents/button";
import useDebounce from "../../../hooks/debounceHook";
import useLang from "../../../hooks/useLang";
import OttoLinkIcon from "../../../icons/js/OttoLinkIcon";
import { AccessPermissionAction } from "../../../library/constants";
import { checkAccessPermission, openDialog } from "../../../library/helpers";
import { addScheduledMessage } from "../../../redux/slices/leadSlice";
import { makeVoiceCall } from "../../../utils";
import { handleMediaEvent } from "./engagementActivity";
import { APPOINTMENT_LINK_TEMPLATE, buildLinkedContentFragment } from "./engagementHelpers";
import EmojiPicker from "./mediaSharing/emojiPicker";
import GifPickerComponent from "./mediaSharing/gifPicker";
import MmsMediaButtons from "./mmsMediaButtons";
import ScheduleMessagesPopup from "./scheduleMessagesPopup";
import { ScheduledJSX } from "./Emails";
import { TEMPLATE_ENUMS } from "../../../constant/EmailConstant";
import { TEMPLATE_LIST_PAGE_SIZE } from "../../../constant/TemplateConstant";
import { buildTemplateQueryVariables, getTemplateList } from "../../../helpers/templateHelpers";
import VehicleDetailPage from "./VDP/VehicleDetailPage";
import OttoVinPanel from "./OttoVin/OttoVinPanel";

export function BottomActions({
  handleFiles,
  fetchData,
  setMediaUploadLoader,
  handleMMS,
  emailForm,
  onlyFirstMessage,
  onClickHandler,
  tooltipTitle,
  afterMessageConsent,
  setCallConsentMessage,
  sendConsentMessage,
  isConsentStatusEnable,
  attachments,
  handleMediaSharing,
  mediaRef,
  videoRef,
  documentRef,
  setAttachments,
  text,
  selectedLead,
  user,
  setTemplateModal,
  showReviewRequestButton = true,
  setmessageText,
  setisReview,
  activeOppName,
  textMode,
  messageText,
  handleSetDefinedTemplate,
  handleAddAppointment,
  scheduledMessages,
  getMessages,
  setrichTextValue,
  richTextValue,
  buttonDisabled,
  messageLoader,
  loading,
  spinner,
  leadsLoading,
  mmsLoader,
  buttonStyle,
  setmmsLoader,
  setSummaryVisible,
  summaryVisible,
  setscheduledMessageDrawer,
  crmIntegrationType,
  opportunityList,
  addSignature,
  emailCursor,
  emailTextRef,
  selectedOppTypeId,
}) {
  const [lang] = useLang();
  const [loaderFn, setloaderFn] = useState(false);
  const [mediaProcessingLoader, setMediaProcessingLoader] = useState(false);
  const [selectedScheduleEmail, setselectedScheduleEmail] = useState(null);
  const [scheduleMessageForm, setscheduleMessageForm] = useState({
    open: false,
    textMode: "Message",
    mode: "ADD",
  });
  const [vdpDrawerOpen, setVdpDrawerOpen] = useState(false);
  const [ottoVinDrawerOpen, setOttoVinDrawerOpen] = useState(false);
  const { textMode: textModeRedux, messageOpportunity } = useSelector(state => state.lead);
  const { email } = useSelector(state => state.user);
  const popoverRef = useRef(null);
  const schedulePopupRef = useRef();
  const dispatch = useDispatch();
  const [getMessageText, { loading: appointmentLinkLoading }] = useLazyQuery(
    GET_ENGAGEMENT_TEMPLATE_TEXT,
    {
      fetchPolicy: "cache-first",
    }
  );
  const [createScheduledMessage, { loading: createScheduledMessageLoader }] =
    useMutation(CREATE_SCHEDULED_MESSAGE);

  // "Print Dealer Document" is shown only when this company + active location
  // has at least one active company_document (dealer-agnostic — any CRM). The
  // list query itself filters by company_id + location_id + is_active.
  const bottomActionsLocationId = (sessionStorage.getItem("currentLocationId") || "").includes(",")
    ? sessionStorage.getItem("currentLocationId").split(",")[0]
    : sessionStorage.getItem("currentLocationId");
  const { data: companyDocumentsData } = useQuery(GET_COMPANY_DOCUMENTS, {
    fetchPolicy: "cache-and-network",
    skip: !user?.company?.id || !bottomActionsLocationId,
    variables: {
      companyId: user?.company?.id,
      locationId: bottomActionsLocationId,
      page: 1,
      pageSize: 1,
    },
  });
  const hasDealerDocuments = (companyDocumentsData?.getCompanyDocuments?.count || 0) > 0;
  // A schedule is always expressed in the location's timezone, never the
  // browser's — the dealership operates in one zone, its staff may not.
  // Under "All locations" it's the LEAD's location that decides.
  const scheduleTimeZone = useMemo(
    () => getScheduleTimezone(user, selectedLead?.location),
    [user, selectedLead?.location]
  );
  const canShareVDP = checkAccessPermission(AccessPermissionAction.VDP_FEATURE_VIEW);
  // OttoVin: gated on the SEND action of OTTOVIN_MANAGEMENT (backend-seeded;
  // platform admins bypass via checkAccessPermission).
  const canSendOttoVin = checkAccessPermission(AccessPermissionAction.OTTOVIN_SEND);

  const canSendEmail = checkAccessPermission(AccessPermissionAction.EMAIL_MANAGEMENT_SEND);

  const canAudioCall = checkAccessPermission(AccessPermissionAction.CALL_MANAGEMENT_AUDIO);
  const canVideoCall = checkAccessPermission(AccessPermissionAction.CALL_MANAGEMENT_VIDEO);

  const handleInsertLink = urlString => {
    const editor = document.getElementById("rich-text");
    editor.focus(); // Ensure editor is focused

    if (!emailCursor) return; // If no cursor position saved, do nothing

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(emailCursor); // Restore cursor position

    // Each line is either a bare URL or a label followed by a URL (the VDP and
    // appointment formats) — only the URL is hyperlinked.
    const range = selection.getRangeAt(0);
    range.deleteContents(); // Remove any selected text
    range.insertNode(buildLinkedContentFragment(urlString));

    // Move cursor after the inserted content
    range.collapse(false);
    selection.removeAllRanges();
    selection.addRange(range);
  };

  const handleInsertSnippet = snippet => {
    const editor = document.getElementById("rich-text");
    editor.focus(); // Ensure editor is focused

    if (!emailCursor) return; // If no cursor position saved, do nothing

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(emailCursor); // Restore cursor position

    // Insert snippet at restored cursor position
    const range = selection.getRangeAt(0);
    range.deleteContents(); // Remove any selected text

    const snippetNode = document.createTextNode(snippet);
    range.insertNode(snippetNode);

    // Move cursor after snippet
    range.setStartAfter(snippetNode);
    range.setEndAfter(snippetNode);
    selection.removeAllRanges();
    selection.addRange(range);
  };
  const handleSendAppointmentLink = async () => {
    const existingText = text.current.value;
    // Append the appointment placeholder with exactly one separating space so
    // it never concatenates with (or doubles the space after) existing text.
    // The label travels with the placeholder so the BE expands the URL in
    // place and the recipient gets "Schedule appointment here: <short url>".
    const requestContent = existingText
      ? `${existingText.replace(/\s+$/, "")} ${APPOINTMENT_LINK_TEMPLATE}`
      : APPOINTMENT_LINK_TEMPLATE;
    // Opp-scope hints for the {createAppointmentUrl} expansion. Priority
    // matches what the user requested: when a specific opp is picked
    // in the thread dropdown, send leadOpportunityId so the link pins
    // exactly to that opp; otherwise when only an opp-type tab is
    // active (e.g. "All Sales"), send oppTypeId (the root id) so the
    // BE resolves to the most-recent active opp of that type. When
    // neither is set, both stay null and the BE falls back to the
    // legacy "most-recently-updated active opp" behavior.
    const resolvedLeadOppId = resolveLeadOpportunityId(messageOpportunity);
    const res = await getMessageText({
      variables: {
        leadId: selectedLead.id,
        content: requestContent,
        leadOpportunityId: resolvedLeadOppId || null,
        oppTypeId: resolvedLeadOppId ? null : selectedOppTypeId || null,
      },
    });
    if (res.data.getEngagementTemplateText.statusCode === 200) {
      const { content } = res.data.getEngagementTemplateText;
      if (textModeRedux === "Email") {
        handleInsertLink(content || "");
      } else {
        text.current.value = content;
        text.current.style.height = `${text.current.scrollHeight}px`;
        setmessageText(content);
      }
    } else {
      message.error(res.data.getEngagementTemplateText.message);
    }
  };
  const Attachments = () => {
    return (
      <div className="flex flex-col justify-center  gap-5">
        {!attachments.some(file => file?.file?.type?.includes("gif") || false) && (
          <MmsMediaButtons
            handleMediaSharing={handleMediaSharing}
            mediaRef={mediaRef}
            videoRef={videoRef}
            documentRef={documentRef}
            handleMediaEvent={e =>
              handleMediaEvent(e, attachments, setAttachments, setMediaProcessingLoader)
            }
            mediaProcessingLoader={mediaProcessingLoader}
          />
        )}{" "}
        {attachments.length === 0 && (
          <div key="gifPicker" className="icon-wrapper">
            <Popover
              showArrow={false}
              content={
                <div onClick={e => e.stopPropagation()}>
                  <GifPickerComponent
                    attachments={attachments}
                    setAttachments={setAttachments}
                    selectedLead={selectedLead}
                    user={user}
                  />
                </div>
              }
              trigger="click"
              destroyTooltipOnHide
            >
              <span className="flex items-center justify-start cursor-pointer">
                <LuImagePlay size={18} strokeWidth={1.75} className="icon-action-color mr-1.5" />
                Select GIF
              </span>
            </Popover>
          </div>
        )}{" "}
      </div>
    );
  };
  const [getReviewMessage, { loading: reviewInviteLoading }] = useLazyQuery(
    GET_INITIAL_REVIEW_MESSAGE,
    {
      fetchPolicy: "network-only",
    }
  );

  const handleReviewInvite = async () => {
    const res = await getReviewMessage({
      variables: {
        leadId: selectedLead.id,
        // Single-argument form, same as CREATE_MESSAGE: send the pinned thread
        // opp when there is one, otherwise null and let the BE resolve from the
        // active tab below. The old second argument guessed at the last
        // message's opp precisely because there was no tab to fall back on —
        // now there is, so the guess can go.
        leadOpportunityId: resolveLeadOpportunityId(messageOpportunity),
        selectedOppTypeId: selectedOppTypeId || null,
      },
    });
    if (res?.data?.getInitialReviewMessage?.statusCode === 200) {
      const content = res?.data?.getInitialReviewMessage?.content;
      if (textModeRedux === "Email") {
        handleInsertSnippet(content);
      } else {
        text.current.value = content;
        text.current.style.height = `${text.current.scrollHeight}px`;
        setmessageText(content);
      }
      setisReview(true);
    } else {
      message.error("Failed to generate review message. Please contact support.");
    }
  };

  const handleVoiceCall = async () => {
    if (!selectedLead?.id || !user?.id) {
      message.error("Missing lead or user information");
      return;
    }

    const currentLocationId = sessionStorage.getItem("currentLocationId");
    const locationId = currentLocationId?.includes(",")
      ? currentLocationId.split(",")[0]
      : currentLocationId;

    if (!locationId) {
      message.error("Missing location information");
      return;
    }

    await makeVoiceCall({
      location_id: locationId,
      user_id: user.id.toString(),
      lead_id: selectedLead.id.toString(),
    });
  };

  const OttoLinks = () => {
    return (
      <div className="flex flex-col justify-center gap-5">
        {hasDealerDocuments && (
          <span
            onClick={() => {
              openDialog("documentSelector", {
                width: "620px",
                dialogHeader: "Print Dealer Documents",
                leadId: selectedLead?.id,
                activeOppName: activeOppName,
                opportunityList: opportunityList,
              });
            }}
            className="flex items-center justify-start cursor-pointer"
          >
            <LuFileText size={18} strokeWidth={1.75} className="icon-action-color mr-1.5" />
            Print Dealer Document
          </span>
        )}

        <span
          onClick={() => handleSendAppointmentLink()}
          className="flex items-center justify-start cursor-pointer"
        >
          <LuCalendarPlus size={18} strokeWidth={1.75} className="icon-action-color mr-1.5" />
          Attach Appointment Link
        </span>
        {showReviewRequestButton && (
          <span
            onClick={() => handleReviewInvite()}
            className="flex items-center justify-start cursor-pointer"
          >
            <LuMessageSquareQuote
              size={18}
              strokeWidth={1.75}
              className="icon-action-color mr-1.5"
            />
            Review Invite
          </span>
        )}
        {textModeRedux === "Text" && (
          <span
            onClick={() => setTemplateModal({ visible: true })}
            className="flex items-center justify-start cursor-pointer"
          >
            <LuLayoutTemplate size={18} strokeWidth={1.75} className="icon-action-color mr-1.5" />
            Select Template
          </span>
        )}
        {canShareVDP && (
          <span
            onClick={() => setVdpDrawerOpen(true)}
            className="flex items-center justify-start cursor-pointer"
          >
            <LuCar size={18} strokeWidth={1.75} className="icon-action-color mr-1.5" />
            VDP
          </span>
        )}
        {canSendOttoVin && selectedLead?.id && (
          <span
            onClick={() => setOttoVinDrawerOpen(true)}
            className="flex items-center justify-start cursor-pointer"
          >
            <LuCar size={18} strokeWidth={1.75} className="icon-action-color mr-1.5" />
            OttoVin
          </span>
        )}
      </div>
    );
  };
  const CallLinks = ({ permission }) => {
    return (
      <div className="flex flex-col justify-center gap-5">
        <span
          className={`flex items-center justify-start cursor-pointer ${
            !permission.canAudioCall ? "opacity-50 pointer-events-none" : ""
          }`}
          onClick={permission.canAudioCall ? handleVoiceCall : undefined}
        >
          <LuPhone size={18} strokeWidth={1.75} className="icon-action-color mr-1.5" />
          Voice Call
        </span>
        <span
          className={`flex items-center justify-start cursor-pointer ${
            !permission.canVideoCall ? "opacity-50 pointer-events-none" : ""
          }`}
          // Add your onClick handler here if needed
        >
          <LuVideo size={18} strokeWidth={1.75} className="icon-action-color mr-1.5" />
          Video Call
        </span>
      </div>
    );
  };

  const Signature = () => {
    return (
      <div className="flex flex-col justify-center gap-5">
        <span
          // onClick={() => handleSendReviewClick()}
          onClick={() =>
            openDialog("emailSignature", {
              dialogHeader: "Email Signature",
              width: "700px",
              mode: "EDIT",
              addSignature,
            })
          }
          className="flex items-center justify-start cursor-pointer"
        >
          <LuPencil size={18} strokeWidth={1.75} className="icon-action-color mr-1.5" />
          Edit Signature
        </span>
        <span
          onClick={() =>
            openDialog("emailSignature", {
              dialogHeader: "Email Signature",
              width: "700px",
              mode: "ADD",
              addSignature,
            })
          }
          className="flex items-center justify-start cursor-pointer"
        >
          <LuPlus size={18} strokeWidth={1.75} className="icon-action-color mr-1.5" />
          Insert Signature
        </span>
      </div>
    );
  };
  const InsertFields = () => {
    const [search, setsearch] = useState("");
    const arr = [
      "{dealerName}",
      "{companyName}",
      "{leadOwner}",
      "{userFullName}",
      "{userName}",
      "{userFirstName}",
      "{userLastName}",
      "{fullName}",
      "{firstName}",
      "{lastName}",
      "{leadFullName}",
      "{leadFirstName}",
      "{leadLastName}",
      "{sourceName}",
      "{previousVehicle}",
      "{currentVehicle}",
      "{vehicleOfInterest}",
      "{primaryVehicle}",
      "{locationName}",
      "{locationAddress}",
      "{locationUrl}",
      "{createAppointmentUrl}",
    ];
    return (
      <div>
        <Input
          onChange={e => setsearch(e.target.value)}
          onClick={e => e.stopPropagation()}
          placeholder="Search snippets"
        />
        <div className="flex-col-centered gap-2 overflow-y-auto h-[200px]">
          {arr
            .filter(item =>
              isEmpty(search) ? item : item.toLowerCase().includes(search.toLowerCase())
            )
            .map((item, index) => (
              <span
                onClick={e => {
                  e.stopPropagation();
                  handleInsertSnippet(item);
                }}
                className="cursor-pointer"
                key={index}
              >
                {item}
              </span>
            ))}
        </div>
      </div>
    );
  };
  const EmailTemplate = () => {
    const [lang] = useLang();
    const [emailTemplates, setemailTemplates] = useState([]);
    const [search, setsearch] = useState("");
    const { loading: emailTemplateLoader } = useQuery(GET_ENGAGEMENT_MESSAGE_TEMPLATES, {
      variables: buildTemplateQueryVariables({
        scope: null,
        companyId: user.company.id,
        userId: user.id,
        templateType: TEMPLATE_ENUMS.EMAIL,
        isActive: true,
        search, // Pass search term to the query
        pageSize: TEMPLATE_LIST_PAGE_SIZE,
      }),
      onCompleted: res => {
        setemailTemplates(getTemplateList(res));
      },
      // A template saved in the Email Template tab must show up the next time
      // this picker opens; the default cache-first policy kept serving the list
      // from before the save until a full page refresh (EAI-1839).
      fetchPolicy: "network-only",
    });
    const [getEngagementTemplateText] = useLazyQuery(GET_ENGAGEMENT_TEMPLATE_TEXT);
    const parseTemplate = async template => {
      const payload = {
        content: template?.message,
        leadId: selectedLead.id,
      };
      const res = await getEngagementTemplateText({
        variables: payload,
      });
      emailTextRef.current.innerHTML = res?.data?.getEngagementTemplateText?.content;
      emailForm.setFieldValue("subject", template?.subject);
    };
    return (
      <div className="p-2">
        <Input
          onClick={e => e.stopPropagation()}
          placeholder={lang?.searchTemplate}
          disabled={isEmpty(emailTemplates)}
          onChange={e => setsearch(e.target.value)}
        />
        <div className="flex-col-centered gap-1 mt-1">
          <Skeleton loading={emailTemplateLoader} active paragraph={{ rows: 4 }}>
            {!isEmpty(emailTemplates) ? (
              emailTemplates?.map((option, index) => (
                <span
                  key={index}
                  onClick={e => {
                    // e.stopPropagation();
                    parseTemplate(option);
                  }}
                  className="p-1 cursor-pointer"
                >
                  {option.title || ""}
                </span>
              ))
            ) : (
              <p className="text-gray-500 m-0 mt-1">{lang?.noTemplates}</p>
            )}
          </Skeleton>
        </div>
      </div>
    );
  };
  const OptoutErrorMessage = "Lead has opted out, you cannot message this lead now!";
  const ErrorPopover = <Alert type="error" showIcon message={OptoutErrorMessage} />;

  const bottomActions = [
    {
      render: (
        <EmojiPicker
          key={`emjoi_picker_${selectedLead?.id}`}
          textMode={textMode}
          handleSetDefinedTemplate={handleSetDefinedTemplate}
          text={text}
          messageText={messageText}
          emailCursor={emailCursor}
          emailTextRef={emailTextRef}
        />
      ),
      title: "Emoji",
      icon: <LuSmile size={18} strokeWidth={1.75} className="icon-action-color" />,
      autoCloseDisabled: true,
    },
    {
      render: <Attachments />,
      icon: <LuPaperclip size={18} strokeWidth={1.75} className="icon-action-color" />,
      title: "Attach File",
    },
    {
      render: <OttoLinks />,
      icon: <OttoLinkIcon color="black" />,
      title: "Otto Links",
    },
    ...(textModeRedux === "Text"
      ? [
          {
            render: <CallLinks permission={{ canAudioCall, canVideoCall }} />,
            icon: <LuPhone size={18} strokeWidth={1.75} className="icon-action-color" />,
            title: "Audio & video call",
          },
          {
            render: null,
            icon: (
              <LuCalendarCheck
                size={18}
                strokeWidth={1.75}
                className="icon-action-color"
                onClick={e => {
                  if (buttonDisabled()) {
                    message.error(OptoutErrorMessage);
                    return;
                  }
                  // Reset Opp Type / Opp Status filters and re-apply default
                  // "all statuses" for appointments before opening the drawer,
                  // mirroring the signout reset.
                  dispatch(resetAppointmentFilters());
                  handleAddAppointment(e);
                }}
                showBG
                bgColor="#E2E8F0"
              />
            ),
            title: "Add Appointment",
          },
          {
            icon: <div className="h-[20px] w-[2px] bg-gray-500" />,
            hover: false,
          },
          {
            icon: (
              <span className="flex-row-centered gap-1 items-center">
                <LuNotebookPen
                  size={18}
                  strokeWidth={1.75}
                  className="icon-action-color"
                  onClick={() =>
                    setSummaryVisible(prev => ({
                      visible: true,
                      count: prev.count + 1,
                    }))
                  }
                />
                {summaryVisible.visible && (
                  <LuCircleX
                    size={18}
                    strokeWidth={1.75}
                    className="icon-action-color cursor-pointer"
                    onClick={() => setSummaryVisible({ visible: false, count: 0 })}
                  />
                )}
              </span>
            ),
            render: null,
            title: "Conversation summary",
          },
        ]
      : canSendEmail
      ? [
          // {
          //   icon: <SignatureIcon />,
          //   render: <Signature />,
          //   title: "Add Signature",
          // },
          {
            icon: <div className="h-[20px] w-[2px] bg-gray-500" />,
            hover: false,
          },
          {
            icon: (
              <span className="flex-row-centered items-center gap-[7px]">
                <LuMailSearch size={18} strokeWidth={1.75} className="icon-action-color" />
                <span className="text-grey-700 font-[400]">Use Template</span>
              </span>
            ),
            render: <EmailTemplate />,
            title: "Use Template",
            // Remount on every open so the query above actually re-runs.
            destroyOnHide: true,
          },
          {
            icon: (
              <span className="flex-row-centered items-center gap-[7px]">
                <LuBraces size={18} strokeWidth={1.75} className="icon-action-color" />
                <span className="text-grey-700 font-[400]">Insert Fields</span>
              </span>
            ),
            title: "Insert Fields",
            render: <InsertFields />,
          },
        ]
      : []),
  ];
  const [createScheduledEmail] = useMutation(CREATE_SCHEDULED_EMAIL);
  const [updateScheduledEmail] = useMutation(UPDATE_SCHEDULED_EMAIL);
  const handleQuickSchedule = async (date, mode) => {
    try {
      const isEmail = mode === "Email";
      // console.log("handleQuickSchedule => Called");
      if (isEmail) {
        if (emailForm.getFieldValue("subject") === "" || emailTextRef.current.innerHTML === "") {
          return message.error("Please enter the subject and body of the email");
        }
        // console.log("handleQuickSchedule:attachments", attachments);
        let mmsArr = [];
        if (attachments.length > 0) {
          mmsArr = await handleFiles(
            attachments.filter(file => file.mediaUrl.includes("localhost")),
            user,
            selectedLead,
            fetchData,
            setMediaUploadLoader
          );
        }
        const payload = {
          subject: emailForm.getFieldValue("subject"),
          body: emailTextRef.current.innerHTML,
          leadId: selectedLead.id,
          to: emailForm.getFieldValue("to"),
          scheduledDate: date,
          timezone: scheduleTimeZone,
          // Same opportunity targeting as an immediate send (CREATE_MESSAGE)
          // and as the EmailSchedule path below: the explicit thread opp when
          // one is chosen, otherwise the active Sales / Service / Parts tab.
          leadOpportunityId: resolveLeadOpportunityId(messageOpportunity),
          selectedOppTypeId: selectedOppTypeId || null,
          id: selectedScheduleEmail?.id,
          attachments: [
            ...mmsArr,
            ...attachments.filter(file => !file.mediaUrl.includes("localhost")),
          ],
        };
        if (selectedScheduleEmail?.id) {
          const scheduleEmailRes = await updateScheduledEmail({
            variables: payload,
          });
          if (scheduleEmailRes.data.updateScheduledEmail.statusCode === 200) {
            message.success(scheduleEmailRes.data.updateScheduledEmail.message);
            emailForm.resetFields();
            emailTextRef.current.innerHTML = "";
            setselectedScheduleEmail(null);
            getMessages({ variables: { leadId: selectedLead?.id, page: 1 } });
            return true;
          }
          message.error(scheduleEmailRes.data.updateScheduledEmail.message);
          return false;
        }
        const scheduleEmailRes = await createScheduledEmail({
          variables: payload,
        });
        if (scheduleEmailRes.data.createScheduledEmail.statusCode === 200) {
          message.success(scheduleEmailRes.data.createScheduledEmail.message);
          emailForm.resetFields();
          emailTextRef.current.innerHTML = "";
          setselectedScheduleEmail(null);
          getMessages({ variables: { leadId: selectedLead?.id, page: 1 } });
          return true;
        }
        message.error(scheduleEmailRes.data.createScheduledEmail.message);
        return false;
      }
      if (text.current.value === "") {
        return message.error("Please enter a message first");
      }
      const obj = {
        leadId: selectedLead?.id,
        message: text.current.value,
        scheduledDate: date,
        timezone: scheduleTimeZone,
        // Same opportunity targeting as an immediate send (CREATE_MESSAGE):
        // the explicit thread opp when one is chosen, otherwise the active
        // Sales / Service / Parts tab so the BE attaches the message to the
        // right opportunity instead of the most-recent-opp default.
        leadOpportunityId: resolveLeadOpportunityId(messageOpportunity),
        selectedOppTypeId: selectedOppTypeId || null,
      };
      const res = await createScheduledMessage({
        variables: { ...obj },
      });
      if (res.data.createScheduledMessage.statusCode === 200) {
        text.current.value = "";
        text.current.style.height = "0px";
        setmessageText("");
        const newScheduledMessage = res.data.createScheduledMessage.scheduledMessage;
        dispatch(addScheduledMessage(newScheduledMessage));
        message.success(res.data.createScheduledMessage.message);
        // Refetch messages from page 1 to show the scheduled message at the top
        getMessages({
          variables: {
            leadId: selectedLead?.id,
            page: 1,
          },
        });
      } else {
        message.error(res.data.createScheduledMessage.message);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const [scheduleEmailDrawer, setscheduleEmailDrawer] = useState({
    visible: false,
    emails: [],
  });
  const { data: scheduledEmailsData, refetch: refetchScheduledEmailsForLead } = useQuery(
    GET_SCHEDULED_EMAILS_FOR_LEAD,
    {
      fetchPolicy: "network-only",
      variables: {
        leadId: selectedLead.id,
        // Scope the list to the same opportunity the thread is showing, the
        // way messagesV2 does — otherwise the drawer lists schedules from
        // every opportunity while the thread shows one.
        leadOpportunityId: resolveLeadOpportunityId(messageOpportunity),
        selectedOppTypeId: selectedOppTypeId || null,
      },
      skip: !selectedLead?.id,
    }
  );
  const scheduledEmails = scheduledEmailsData?.getScheduledEmailsForLead || [];
  const refetchScheduledEmailsForLeadHandler = () => refetchScheduledEmailsForLead();

  // Cancelling a schedule changes the TIMELINE too, not just the list: the
  // thread carries a "Scheduled Email" row for it, which otherwise sat there
  // as though the email were still queued until something else reloaded the
  // messages. Creating and updating a schedule already call `getMessages()`
  // for the same reason.
  const refetchAfterScheduleCancel = async () => {
    await refetchScheduledEmailsForLeadHandler();
    // Page 1 explicitly, the same as the scheduled-MESSAGE cancel
    // (viewScheduledMessagesPopup). A bare `getMessages()` reuses
    // `messageFilters`, which after scrollback holds page N and that page's
    // lastId — so the response wouldn't contain the row that was just removed.
    getMessages({ variables: { leadId: selectedLead?.id, page: 1 } });
  };
  // "Update" keeps the email's existing send time — the common case is fixing a
  // typo, not rescheduling. Picking a new time still works via Schedule.
  const [updateScheduleLoading, setUpdateScheduleLoading] = useState(false);
  // A time picked in the Reschedule dialog is held here until the user commits
  // with "Update", so content and timing save together as one change and the
  // banner can show what is about to be applied.
  const [pendingScheduleAt, setPendingScheduleAt] = useState(null);
  const effectiveScheduleAt = pendingScheduleAt || selectedScheduleEmail?.taskSendDatetime;

  const handleUpdateSchedule = async () => {
    setUpdateScheduleLoading(true);
    try {
      // `taskSendDatetime` is stored UTC, but the mutation expects wall-clock
      // digits to pair with `timezone` — sending it raw would have the backend
      // convert an already-converted time, shifting the email by the offset on
      // every Update. A time staged in the dialog is already wall-clock.
      const scheduleAt = pendingScheduleAt
        ? effectiveScheduleAt
        : formatDate(
            effectiveScheduleAt,
            DATE_TIME_FORMATS.YYYY_MM_DD_T_HH_MM_SS,
            scheduleTimeZone
          );
      await handleQuickSchedule(scheduleAt, "Email");
      await refetchScheduledEmailsForLeadHandler();
      setPendingScheduleAt(null);
    } finally {
      setUpdateScheduleLoading(false);
    }
  };

  // Leaves the scheduled email untouched and clears the composer — without this
  // the edit stays armed and the next schedule would silently overwrite it.
  const discardScheduleEdit = () => {
    setselectedScheduleEmail(null);
    setPendingScheduleAt(null);
    emailForm.resetFields();
    if (emailTextRef.current) emailTextRef.current.innerHTML = "";
  };

  // Switching to Text deliberately keeps the edit intact — the banner is simply
  // not rendered outside Email mode. Nothing in Text mode can touch a scheduled
  // email, so the edit is safe to leave armed, and coming back restores the
  // banner along with the subject and body that were already in the composer.

  const sendMenu = mode => {
    const isEmail = mode === "Email";
    const close = () => schedulePopupRef.current.click();
    return (
      <div className="flex flex-col items-start gap-2" onClick={e => e.stopPropagation()}>
        <span className="text-sm text-[#64748B] font-[400] ">Schedule {mode}</span>
        <span
          onClick={() => {
            if (isEmail) {
              if (
                emailForm.getFieldValue("subject") === "" ||
                emailTextRef.current.innerHTML === ""
              ) {
                return message.error("Please enter the subject and body of the email");
              }
              setscheduleMessageForm({ open: true, textMode: mode, mode: "ADD" });
              close();
            } else {
              if (text.current.value === "") return message.error("Please enter a message first");
              setscheduleMessageForm({ open: true, textMode: mode, mode: "ADD" });
              close();
            }
          }}
          className="text-[16px] font-[400] text-grey-700 cursor-pointer"
        >
          Select custom date & time
        </span>
        {isEmail
          ? scheduledEmails.length > 0 && (
              <>
                <div className="h-[1px] w-full bg-[#CBD5E1]" />
                <span
                  className="cursor-pointer text-[16px] font-[500] text-brand-500"
                  onClick={() => {
                    // setscheduledMessageDrawer({ open: true, messages: scheduledMessages });
                    setscheduleEmailDrawer({ visible: true, emails: scheduledEmails });
                    close();
                  }}
                >
                  Scheduled Emails ({scheduledEmails.length})
                </span>
              </>
            )
          : scheduledMessages.length > 0 && (
              <>
                <div className="h-[1px] w-full bg-[#CBD5E1]" />
                <span
                  className="cursor-pointer text-[16px] font-[500] text-brand-500"
                  onClick={() => {
                    setscheduledMessageDrawer({ open: true, messages: scheduledMessages });
                    close();
                  }}
                >
                  Scheduled Messages ({scheduledMessages.length})
                </span>
              </>
            )}
      </div>
    );
  };
  const hasConsent = isConsentStatusEnable(
    selectedLead?.textConsentStatus,
    user?.company?.isOptinConsentMethod
  );
  const consent = useMemo(() => selectedLead?.textConsentStatus, [selectedLead]);
  const { selectedEmail } = useSelector(state => state.lead);
  const [saveAsDraft, { loading: saveAsDraftLoader }] = useMutation(SAVE_AS_DRAFT);
  const [draftSaved, setdraftSaved] = useState(false);

  const saveDraft = async () => {
    // console.log("========== saveDraft", email);
    if (email.email !== "" && email.subject !== "") {
      try {
        await saveAsDraft({
          variables: {
            draftType: "EMAIL",
            leadId: selectedLead.id,
            companyId: user.company.id,
            locationId: sessionStorage.getItem("currentLocationId")?.includes(",")
              ? null
              : sessionStorage.getItem("currentLocationId"),
            userId: user.id,
            body: email.body,
            subject: email.subject,
            receiver: email.email,
          },
        });
        setdraftSaved(true);
      } catch (error) {
        console.error("Error saving draft:", error);
      }
    }
  };

  // Create debounced version of your function (800ms delay)
  const debouncedSaveDraft = useDebounce(saveDraft, 2 * 1000, [email]);

  useEffect(() => {
    // console.log("========== email", email);
    debouncedSaveDraft();
  }, [email]);

  return (
    <Spin
      spinning={reviewInviteLoading || appointmentLinkLoading || mmsLoader}
      tip={mmsLoader ? "Uploading media..." : undefined}
    >
      {/* Editing an existing scheduled email is otherwise invisible state —
          without this the composer looks like a fresh one, and the only way to
          save was to re-open Schedule and pick a date again. Email mode only. */}
      {textModeRedux === "Email" && selectedScheduleEmail?.id && (
        <div className="flex items-center gap-2 mx-2 mt-2 px-3 py-2 rounded-md bg-brand-50 border border-solid border-brand-200">
          <LuCalendarClock size={15} strokeWidth={1.75} className="shrink-0 text-brand-500" />
          <span className="text-xs text-grey-700 flex-1 min-w-0 truncate">
            Editing scheduled email for{" "}
            <span className="font-medium">
              {formatUtcToLocal(effectiveScheduleAt, DATE_TIME_FORMATS.MMM_DD_YYYY_hh_mm_A)}
            </span>
          </span>
          <CustomButton
            size="small"
            type="primary"
            btnText="Update"
            loading={updateScheduleLoading}
            handleClick={handleUpdateSchedule}
            tooltipTitle="Save your changes"
          />
          <CustomButton
            size="small"
            btnText="Change time"
            handleClick={() =>
              setscheduleMessageForm({ open: true, textMode: "Email", mode: "EDIT" })
            }
            tooltipTitle="Pick a different date and time"
          />
          <CustomButton size="small" btnText="Discard" handleClick={discardScheduleEdit} />
        </div>
      )}
      <div className="flex-row-centered justify-between w-full p-2">
        <div className="flex-row-centered gap-2 items-center">
          {hasConsent &&
            bottomActions.map((item, index) => {
              const actionProps = {
                buttonDisabled,
                ErrorPopover,
                item,
                hover: item.hover ?? true,
                index,
              };
              return <Actions key={index} {...actionProps} />;
            })}
        </div>
        <div className="flex-row-centered gap-3 items-center">
          {draftSaved && textModeRedux !== "Text" && (
            <span className="italic text-grey-100 flex-row-centered gap-1">
              {saveAsDraftLoader ? "Saving Draft..." : "Draft Saved"}
            </span>
          )}
          {hasConsent && (
            <Tooltip title={textModeRedux === "Text" ? "Schedule message" : "Schedule an email"}>
              <Popover
                trigger={["click"]}
                content={
                  buttonDisabled()
                    ? ErrorPopover
                    : textModeRedux === "Text"
                    ? sendMenu("Message")
                    : sendMenu("Email")
                }
              >
                <Badge
                  className="testing"
                  count={
                    textModeRedux === "Text" ? scheduledMessages.length : scheduledEmails.length
                  }
                  size="small"
                >
                  <span
                    className="px-1 flex-row-centered justify-center cursor-pointer hover:bg-[#E2E8F0] rounded-[4px] p-1"
                    type="text"
                    ref={schedulePopupRef}
                  >
                    <LuClock size={18} strokeWidth={1.75} className="icon-action-color" />
                  </span>
                </Badge>
              </Popover>
            </Tooltip>
          )}
          <Tooltip title={tooltipTitle()}>
            <Button
              className="flex-row-centered gap-1 text-white items-center rounded-[4px]"
              type="primary"
              key={`attach_btn_${selectedLead?.id}`}
              onClick={async () => {
                if (text?.current?.dataset?.aiGenerating === "true") {
                  return message.info("Please wait while AI response is being generated");
                }
                if (mmsLoader) {
                  return message.info("Please wait while we complete the current process");
                }
                let mmsArr = [];
                if (attachments.length > 0 && textModeRedux !== "Email") {
                  setmmsLoader(true);
                  mmsArr = await handleFiles(
                    attachments,
                    user,
                    selectedLead,
                    fetchData,
                    setMediaUploadLoader
                  );
                }
                if (textModeRedux === "Email") {
                  return emailForm.submit();
                }
                if (mmsArr && mmsArr?.length > 0) {
                  return handleMMS(mmsArr);
                }
                if (textModeRedux === "Text") {
                  if (
                    isConsentStatusEnable(
                      selectedLead?.textConsentStatus,
                      user?.company?.isOptinConsentMethod
                    )
                  ) {
                    if (
                      isEmpty(messageText.trim()) &&
                      isEmpty(textMode === 0 ? text.current.value : richTextValue)
                    ) {
                      return message.error(lang.pleaseEnterMessageToSend);
                    }
                    setmessageText(textMode === 0 ? text.current.value : richTextValue);
                    const rawText = (text.current?.value || "").trim();
                    const richText = (richTextValue || "").trim();
                    const bodyText = textMode === 0 ? rawText : richText;
                    let msg;
                    if (onlyFirstMessage) {
                      if (selectedLead?.messages?.length > 0) {
                        msg = bodyText || (messageText || "").trim();
                      } else {
                        msg =
                          afterMessageConsent !== ""
                            ? `${bodyText} ${afterMessageConsent}`
                            : bodyText;
                      }
                    } else {
                      msg =
                        afterMessageConsent !== ""
                          ? `${bodyText} ${afterMessageConsent}`
                          : bodyText;
                    }
                    // Clear textarea immediately so the user sees the send
                    // is in flight — matches handleKeyUp Enter-send flow.
                    if (text.current) {
                      text.current.value = "";
                      text.current.style.height = "inherit";
                    }
                    setmessageText("");
                    if (textMode !== 0) {
                      setrichTextValue("");
                    }
                    onClickHandler(msg, selectedLead, user?.id);
                  } else {
                    setCallConsentMessage(true);
                    sendConsentMessage();
                  }
                }
              }}
              style={{ ...buttonStyle(), padding: "5px" }}
              loading={messageLoader || loaderFn || mmsLoader}
              disabled={
                buttonDisabled() ||
                !selectedLead?.id ||
                messageLoader ||
                loading ||
                spinner ||
                leadsLoading ||
                textMode !== 0 ||
                loaderFn ||
                mmsLoader ||
                (textModeRedux === "Email" && !selectedEmail?.email)
              }
            >
              Send <LuSend size={16} strokeWidth={1.75} color="white" className="rotate-45" />
            </Button>
          </Tooltip>
        </div>
        <Modal
          footer={null}
          className="normal-popup"
          onCancel={() => setscheduleMessageForm({ open: false })}
          title={
            scheduleMessageForm.mode === "EDIT"
              ? `Reschedule ${scheduleMessageForm.textMode}`
              : `Schedule ${scheduleMessageForm.textMode}`
          }
          open={scheduleMessageForm.open}
        >
          {scheduleMessageForm.textMode === "Email" ? (
            <EmailSchedule
              user={user}
              onPickSendTime={setPendingScheduleAt}
              pendingSendAt={pendingScheduleAt}
              selectedOppTypeId={selectedOppTypeId}
              popoverRef={schedulePopupRef}
              emailForm={emailForm}
              emailTextRef={emailTextRef}
              selectedLead={selectedLead}
              getMessages={getMessages}
              mode={scheduleMessageForm.mode}
              close={() => setscheduleMessageForm({ open: false })}
              refetch={refetchAfterScheduleCancel}
              selectedScheduleEmail={selectedScheduleEmail}
              setselectedScheduleEmail={setselectedScheduleEmail}
              updateScheduledEmail={updateScheduledEmail}
            />
          ) : (
            // Mounted only while open. The Modal keeps its children alive after
            // the first open, and the dialog seeds its fields from these props
            // in a mount-only effect — so without this it would keep showing
            // the message and date from the previous schedule.
            scheduleMessageForm?.open && (
              <ScheduleMessagesPopup
                messageData={{
                  message: textMode === 0 ? text?.current?.value : richTextValue,
                  taskSendDatetime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                }}
                close={() => setscheduleMessageForm({ open: false })}
                mode="ADD"
                selectedOppTypeId={selectedOppTypeId}
                scheduledMessages={scheduledMessages}
                selectedLead={selectedLead}
                getMessages={getMessages}
                setmessageText={setmessageText}
                reset={() => {
                  const resetText = () => {
                    text.current.value = "";
                  };
                  if (textMode === 0) {
                    resetText();
                  } else {
                    setrichTextValue("");
                  }
                }}
              />
            )
          )}
        </Modal>
        <Drawer
          open={scheduleEmailDrawer.visible}
          width="50%"
          title="Scheduled Emails"
          onClose={() => setscheduleEmailDrawer({ visible: false, emails: [] })}
        >
          <ScheduledJSX
            handleEdit={email => {
              setselectedScheduleEmail(email);
              emailTextRef.current.innerHTML = email.body;
              emailForm.setFieldsValue({ to: email.to });
              emailForm.setFieldsValue({ subject: email.subject });
              setscheduleEmailDrawer({ visible: false, emails: [] });
            }}
            emails={scheduleEmailDrawer.emails}
            // Owns the list, so it also owns reloading it after a cancel — the
            // location-wide query inside ScheduledJSX never ran here.
            refetch={refetchAfterScheduleCancel}
            showBody
            showHeader={false}
          />
        </Drawer>
        {vdpDrawerOpen && (
          <VehicleDetailPage
            open={vdpDrawerOpen}
            onClose={() => setVdpDrawerOpen(false)}
            text={text}
            setmessageText={setmessageText}
            handleInsertLink={handleInsertLink}
          />
        )}
        {ottoVinDrawerOpen && (
          <OttoVinPanel
            open={ottoVinDrawerOpen}
            onClose={() => setOttoVinDrawerOpen(false)}
            text={text}
            setmessageText={setmessageText}
            handleInsertLink={handleInsertLink}
            selectedLead={selectedLead}
            selectedOppTypeId={selectedOppTypeId}
          />
        )}
      </div>
    </Spin>
  );
}
export function Actions({ item, hover, buttonDisabled, ErrorPopover }) {
  const [tooltipVisible, settooltipVisible] = useState(false);
  const tooltipRef = useRef(null);
  // Prepare shared hover styles
  const isHoverable = hover !== false; // Treat undefined as true

  return item?.render ? (
    <Popover
      trigger="click"
      // Content is kept mounted between opens by default, which freezes any
      // query inside it; items that need fresh data on each open opt out.
      destroyTooltipOnHide={!!item?.destroyOnHide}
      content={
        <span onClick={() => !item?.autoCloseDisabled && tooltipRef.current.click()}>
          {buttonDisabled() ? ErrorPopover : item.render}
        </span>
      }
    >
      <Tooltip open={tooltipVisible} title={item.title}>
        <span
          className={`flex-row-centered p-1 items-center justify-center ${
            hover && "hover:bg-[#E2E8F0] cursor-pointer"
          } rounded-[4px]`}
          onMouseEnter={() => hover && settooltipVisible(true)}
          onMouseLeave={() => settooltipVisible(false)}
          onClick={() => settooltipVisible(false)}
          ref={tooltipRef}
        >
          {item.icon}
        </span>
      </Tooltip>
    </Popover>
  ) : (
    <Tooltip open={tooltipVisible} title={item.title}>
      <span
        className={`flex-row-centered p-1 items-center justify-center rounded-[4px] ${
          isHoverable ? "hover:bg-[#E2E8F0] !cursor-pointer transition-colors duration-150" : ""
        }`}
        onMouseEnter={() => hover && settooltipVisible(true)}
        onMouseLeave={() => settooltipVisible(false)}
        onClick={() => settooltipVisible(false)}
        ref={tooltipRef}
      >
        {item.icon}
      </span>
    </Tooltip>
  );
}
export const EmailSchedule = ({
  popoverRef,
  emailForm,
  emailTextRef,
  selectedLead,
  getMessages,
  mode = "ADD",
  close,
  refetch,
  selectedScheduleEmail,
  updateScheduledEmail,
  setselectedScheduleEmail,
  // Active Sales / Service / Parts tab, drilled from the composer so a
  // scheduled email targets the same opportunity an immediate send would.
  selectedOppTypeId = null,
  user,
  // When editing an existing scheduled email the picked time is staged in the
  // composer instead of saved here — see handleSchedule.
  onPickSendTime,
  // A time already staged but not yet committed, so reopening this dialog shows
  // what the user last picked rather than the email's saved time.
  pendingSendAt,
}) => {
  const [scheduleForm] = Form.useForm();
  const { messageOpportunity } = useSelector(state => state.lead);
  const [createScheduledEmail, { loading: createScheduledEmailLoader }] =
    useMutation(CREATE_SCHEDULED_EMAIL);

  // The schedule is expressed in the location's timezone — shown, not chosen,
  // so a user can't schedule against a zone the dealership doesn't operate in.
  const timeZone = useMemo(
    () => getScheduleTimezone(user, selectedLead?.location),
    [user, selectedLead?.location]
  );

  // Only working, future days and open hours — same rule as the message
  // scheduler.
  const [workingHours, setWorkingHours] = useState([]);
  useQuery(GET_COMPANY_WORK_HOURS, {
    variables: {
      companyId: user?.company?.id,
      locationId: (sessionStorage.getItem("currentLocationId") || "").includes(",")
        ? selectedLead?.location?.id
        : sessionStorage.getItem("currentLocationId"),
    },
    onCompleted: res => setWorkingHours(res?.getCompanyWorkingHours || []),
  });
  // Drives the time picker: open hours depend on which day is selected.
  const selectedScheduleDate = Form.useWatch("date", scheduleForm);
  const selectedScheduleTime = Form.useWatch("time", scheduleForm);

  // The picked slot as the VIEWER's own clock reads it. The pickers work in the
  // dealership's zone, so someone elsewhere cannot tell when the email really
  // goes out. Null — and the line hides — when both zones agree.
  const viewerEquivalent = useMemo(() => {
    if (!selectedScheduleDate || !selectedScheduleTime) return null;
    const picked = dayjs(selectedScheduleDate)
      .hour(dayjs(selectedScheduleTime).hour())
      .minute(dayjs(selectedScheduleTime).minute())
      .second(0);
    return viewerZoneEquivalent(picked, timeZone);
  }, [selectedScheduleDate, selectedScheduleTime, timeZone]);

  // Editing an existing scheduled email: seed the pickers with its current
  // send time so the user can change the date/time here, not just the content.
  // Clearing them on a fresh compose stops the last edit's values leaking in.
  useEffect(() => {
    const seedFrom = pendingSendAt || selectedScheduleEmail?.taskSendDatetime;
    if (seedFrom) {
      // Seeded in the SCHEDULE's zone — the zone the payload is sent with and
      // the one the working-hours limits are checked against. `.local()` showed
      // the viewer's clock instead, so the digits on screen were not the digits
      // that would be saved.
      //
      // A staged pick (`pendingSendAt`) is ALREADY wall-clock in that zone, so
      // it is read as-is; only the stored UTC value needs converting.
      const sendAt = pendingSendAt
        ? dayjs(pendingSendAt)
        : dayjs(formatDate(seedFrom, DATE_TIME_FORMATS.YYYY_MM_DD_T_HH_MM_SS, timeZone));
      scheduleForm.setFieldsValue({ date: sendAt, time: sendAt });
    } else {
      scheduleForm.resetFields(["date", "time"]);
    }
  }, [selectedScheduleEmail?.id, selectedScheduleEmail?.taskSendDatetime, pendingSendAt]);

  const handleSchedule = async values => {
    const timeComponents = dayjs(values.time);
    const hours = timeComponents.hour();
    const minutes = timeComponents.minute();
    const seconds = timeComponents.second();
    const milliseconds = timeComponents.millisecond();
    // Wall-clock digits, NOT an ISO instant: the backend converts to UTC using
    // the `timezone` sent alongside. `toISOString()` here sent a real UTC
    // instant AND a timezone, leaving the server two contradictory answers —
    // and it was the only one of the four schedule paths doing so.
    const timeStamp = dayjs(values.date)
      .hour(hours)
      .minute(minutes)
      .second(seconds)
      .millisecond(milliseconds)
      .format(DATE_TIME_FORMATS.YYYY_MM_DD_T_HH_MM_SS);

    // Rescheduling an existing email: hand the new time back to the composer
    // and close. Nothing is saved here — the banner shows the pending time and
    // "Update" commits the content and the timing together, as one change.
    if (selectedScheduleEmail?.id && onPickSendTime) {
      onPickSendTime(timeStamp);
      close();
      return;
    }

    if (isEmpty(emailForm.getFieldValue("subject")) || emailTextRef.current.innerHTML === "") {
      return message.error("Please enter the subject and body of the email");
    }
    const payload = {
      scheduledDate: timeStamp,
      timezone: timeZone,
      subject: emailForm.getFieldValue("subject"),
      body: emailTextRef.current.innerHTML,
      leadId: selectedLead.id,
      to: emailForm.getFieldValue("to"),
      id: selectedScheduleEmail?.id,
      // Same opportunity targeting as an immediate send: the pinned thread opp
      // when one is chosen, otherwise the active opp-type tab. Only
      // CREATE_SCHEDULED_EMAIL declares these — an edit keeps the original
      // attribution, so the update call ignores them.
      leadOpportunityId: resolveLeadOpportunityId(messageOpportunity),
      selectedOppTypeId: selectedOppTypeId || null,
    };
    // console.log("===> EmailSchedule:payload", payload);
    if (selectedScheduleEmail?.id) {
      const scheduleEmailRes = await updateScheduledEmail({
        variables: payload,
      });
      if (scheduleEmailRes.data.updateScheduledEmail.statusCode === 200) {
        message.success(scheduleEmailRes.data.updateScheduledEmail.message);
        emailForm.resetFields();
        emailTextRef.current.innerHTML = "";
        setselectedScheduleEmail(null);
        getMessages({ variables: { leadId: selectedLead?.id, page: 1 } });
      } else {
        message.error(scheduleEmailRes.data.updateScheduledEmail.message);
      }
    } else {
      const res = await createScheduledEmail({
        variables: payload,
      });
      if (res.data.createScheduledEmail.statusCode === 200) {
        message.success(res.data.createScheduledEmail.message);
        emailForm.resetFields();
        scheduleForm.resetFields();
        emailTextRef.current.innerHTML = "";
        getMessages({ variables: { leadId: selectedLead?.id, page: 1 } });
        refetch();
        close();
      } else {
        message.error(res.data.createScheduledEmail.message);
      }
    }
  };

  return (
    <Form layout="vertical" form={scheduleForm} onFinish={handleSchedule}>
      <div className="flex-col-centered gap-2 -m-3">
        <div className="flex-row-centered p-3 gap-1">
          <Form.Item
            rules={[{ required: true, message: "Please select the date" }]}
            label="Date"
            className="w-full"
            name="date"
          >
            <DatePicker
              className="w-full"
              name="date"
              disabledDate={getWorkingHoursDisabledDate(workingHours, timeZone)}
            />
          </Form.Item>
          <Form.Item
            label="Time"
            className="w-full"
            rules={[{ required: true, message: "Please select the time" }]}
            name="time"
          >
            <TimePicker
              name="time"
              className="w-full"
              format={DATE_TIME_FORMATS.HH_MM_A}
              use12Hours
              disabled={!selectedScheduleDate}
              disabledTime={() =>
                getWorkingHoursDisabledTime(workingHours, selectedScheduleDate, timeZone)
              }
              showNow={false}
            />
          </Form.Item>
        </div>
        <div className="px-3">
          {/* Shown, not chosen: a schedule is always expressed in the
              location's own timezone. */}
          <p className="m-0 text-sm text-grey-700">
            Timezone: <b>{timeZone || "--"}</b>
          </p>
          {/* Same confirmation line as the message scheduler, so the user sees
              exactly when the lead will receive it before committing. */}
          <span className="text-xs text-grey-700">
            The email will be delivered to the lead on{" "}
            <span className="font-[500]">
              {selectedScheduleDate && selectedScheduleTime
                ? dayjs(selectedScheduleDate)
                    .hour(dayjs(selectedScheduleTime).hour())
                    .minute(dayjs(selectedScheduleTime).minute())
                    .format(DATE_TIME_FORMATS.MMM_DD_YYYY_COMMA_hh_mm_A)
                : "--"}
            </span>
          </span>
          {/* Second reading for anyone whose own clock differs — the picker is
              in the dealership's zone, so "11:00 PM" there is a very different
              hour wherever the user actually is. Hidden when the zones match.
              Kept last: it annotates the delivery time stated above. */}
          {viewerEquivalent && (
            <p className="m-0 text-xs text-grey-500">
              That is <b>{viewerEquivalent.time}</b> in your timezone ({viewerEquivalent.zone}).
            </p>
          )}
        </div>
        <div className="p-3 flex-row-centered gap-1 bg-grey-100">
          <Button
            onClick={() => {
              scheduleForm.resetFields();
              close();
            }}
          >
            Cancel
          </Button>
          <Button type="primary" loading={createScheduledEmailLoader} htmlType="submit">
            {/* Editing an existing scheduled email updates it rather than
                queueing a second one — the label should say so. */}
            {selectedScheduleEmail?.id ? "Reschedule" : "Schedule"}
          </Button>
        </div>
      </div>
    </Form>
  );
};
